
<template>
  <el-button
    v-if="theme == 'button'"
    :type="type ? type : item.type"
    :size="size"
    :plain="plain"
    @click="handleClick"
    >{{ label }}</el-button
  >
  <el-tag
    v-else-if="theme == 'tag'"
    :type="type ? type : item.type"
    :size="size"
    :effect="effect"
    @click="handleClick"
    >{{ label }}</el-tag
  >
  <span
    v-else
    class="default"
    :class="(type ? type : item.type) + ' ' + size + ' ' + (clickable ? 'clickable' : '')"
    @click="handleClick"
    >{{ label }}</span
  >
</template>

<script>
export default {
  name: 'dict-view',
  props: {
    options: {
      type: Array,
      default: null
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    labelKey: {
      type: String,
      default: 'label'
    },
    theme: {
      type: String,
      default: 'text'
    },
    type: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Boolean],
      default: undefined
    },
    plain: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    effect: {
      type: String,
      default: 'light'
    },
    clickable: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      default: '--'
    }
  },
  data() {
    return {
      timerId: null,
      label: '--',
      item: { type: 'default' }
    }
  },
  watch: {
    value() {
      this.getLabel()
    },
    options() {
      this.getLabel()
    }
  },
  created() {
    this.getLabel()
  },
  destroyed() {
    if (this.timerId) clearTimeout(this.timerId)
  },
  methods: {
    getLabel() {
      if (this.timerId) clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        if (
          (this.value != null && this.value != undefined && this.options && this.options.length > 0) ||
          this.value == 0
        ) {
          this.item = this.options.find((el) => {
            return el[this.valueKey] == this.value
          })
          if (this.item && this.item[this.labelKey]) this.label = this.item[this.labelKey]
          else {
            this.item = { type: 'default' }
            this.label = this.defaultValue
          }
        }
      }, 100)
    },
    // 点击反馈
    handleClick() {
      if (this.clickable) this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.default {
  color: #333;
  font-size: 14px;
}
.clickable {
  cursor: pointer;
}
.primary {
  color: $el-color-primary;
}
.success {
  color: $el-color-success;
}
.info {
  color: $el-color-info;
}
.warning {
  color: $el-color-warning;
}
.danger {
  color: $el-color-danger;
}
.medium {
  font-size: 14px;
}
.small {
  font-size: 12px;
}
.mimi {
  font-size: 12px;
}
</style>
